export const siteTypes = [
  {
    icon: "ri-building-2-line",
    title: "Site institucional",
    description:
      "Apresente a sua empresa, os seus serviços e os seus diferenciais de forma clara e profissional.",
  },
  {
    icon: "ri-window-line",
    title: "Landing page",
    description:
      "Página focada em conversão para campanhas, lançamentos e captação de contatos.",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "Site corporativo",
    description:
      "Estrutura completa para empresas com múltiplos serviços, unidades e conteúdos.",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Portfólio e catálogo",
    description:
      "Ideal para apresentar produtos, projetos e trabalhos de forma visualmente atrativa.",
  },
];

export const siteAdvantages = [
  {
    icon: "ri-smartphone-line",
    title: "Design responsivo",
    description: "Experiência impecável em celular, tablet e computador.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Otimizado para o Google",
    description: "Estrutura de SEO para o seu site ser encontrado com mais facilidade.",
  },
  {
    icon: "ri-whatsapp-line",
    title: "Integração com WhatsApp",
    description: "Contato direto com o cliente a um clique de distância.",
  },
  {
    icon: "ri-article-line",
    title: "Formulários e contato",
    description: "Captação de leads e mensagens direto no seu e-mail ou painel.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Carregamento rápido",
    description: "Páginas leves para uma navegação fluida e agradável.",
  },
  {
    icon: "ri-rocket-2-line",
    title: "Preparado para evoluir",
    description: "Base sólida para o seu site crescer junto com o negócio.",
  },
];

export const siteSteps = [
  {
    icon: "ri-chat-3-line",
    title: "Conversa inicial",
    description: "Entendemos o seu negócio, os seus objetivos e o que o site precisa resolver.",
  },
  {
    icon: "ri-palette-line",
    title: "Design e estrutura",
    description: "Definimos o visual, a organização das páginas e a experiência do usuário.",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Desenvolvimento",
    description: "Construímos o site com foco em desempenho, responsividade e SEO.",
  },
  {
    icon: "ri-rocket-line",
    title: "Publicação",
    description: "Colocamos o site no ar e acompanhamos os primeiros passos.",
  },
];

export const sitePortfolio = [
  {
    title: "Metalúrgica Prima",
    category: "Site institucional",
    description:
      "Site corporativo para indústria com catálogo de produtos, áreas de atuação e formulário de orçamento integrado.",
    tags: ["Institucional", "Catálogo", "SEO"],
    image:
      "https://readdy.ai/api/search-image?query=modern%20corporate%20industrial%20website%20homepage%20displayed%20on%20a%20laptop%20screen%20in%20a%20bright%20minimal%20office%2C%20clean%20professional%20web%20design%2C%20blue%20accents%2C%20high%20detail&width=800&height=600&seq=nx-port-01&orientation=landscape",
  },
  {
    title: "Café do Vale",
    category: "Loja virtual",
    description:
      "E-commerce de cafés especiais com carrinho, checkout, integração de pagamento e páginas de produto otimizadas.",
    tags: ["E-commerce", "Checkout", "Produtos"],
    image:
      "https://readdy.ai/api/search-image?query=minimal%20ecommerce%20coffee%20shop%20website%20on%20a%20smartphone%20screen%20on%20a%20wooden%20table%2C%20warm%20tones%2C%20clean%20product%20grid%20layout%2C%20professional%20photography&width=800&height=600&seq=nx-port-02&orientation=landscape",
  },
  {
    title: "Clínica Vitalis",
    category: "Landing page",
    description:
      "Landing page de campanha para agendamento de consultas, com foco em conversão e integração com WhatsApp.",
    tags: ["Conversão", "WhatsApp", "Campanha"],
    image:
      "https://readdy.ai/api/search-image?query=clean%20healthcare%20landing%20page%20design%20shown%20on%20a%20desktop%20monitor%20in%20a%20bright%20tidy%20clinic%20waiting%20room%2C%20soft%20neutral%20tones%2C%20professional%20web%20layout&width=800&height=600&seq=nx-port-03&orientation=landscape",
  },
  {
    title: "Studio Aurora",
    category: "Portfólio",
    description:
      "Portfólio visual para escritório de arquitetura com galeria de projetos e apresentação de equipe.",
    tags: ["Portfólio", "Galeria", "Design"],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20architecture%20studio%20portfolio%20website%20displayed%20on%20a%20tablet%20on%20a%20marble%20surface%20with%20soft%20natural%20light%2C%20minimal%20editorial%20layout%2C%20neutral%20tones&width=800&height=600&seq=nx-port-04&orientation=landscape",
  },
  {
    title: "Fit Mais Academia",
    category: "Site institucional",
    description:
      "Site com planos, horários, galeria de modalidades e captação de novos alunos pela internet.",
    tags: ["Planos", "Institucional", "Responsivo"],
    image:
      "https://readdy.ai/api/search-image?query=modern%20fitness%20gym%20website%20homepage%20on%20a%20laptop%20screen%20on%20a%20dark%20desk%20with%20dramatic%20lighting%2C%20dynamic%20energetic%20layout%2C%20professional%20web%20design&width=800&height=600&seq=nx-port-05&orientation=landscape",
  },
  {
    title: "Móveis Lar & Estilo",
    category: "Site e catálogo",
    description:
      "Site de móveis planejados com catálogo por ambiente, orçamento online e valorização da marca.",
    tags: ["Catálogo", "Orçamento", "Marca"],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20furniture%20store%20website%20on%20a%20large%20monitor%20in%20a%20bright%20minimalist%20showroom%2C%20warm%20wooden%20textures%2C%20clean%20product%20catalog%20layout&width=800&height=600&seq=nx-port-06&orientation=landscape",
  },
];

export const siteCases = [
  {
    client: "Metalúrgica Prima",
    segment: "Indústria · Bento Gonçalves (RS)",
    challenge:
      "A empresa não tinha presença online e dependia apenas de indicações para conquistar novos clientes.",
    solution:
      "Criamos um site institucional com catálogo de produtos, estrutura de SEO e formulário de orçamento direto.",
    results: [
      { icon: "ri-global-line", label: "Presença online consolidada" },
      { icon: "ri-time-line", label: "Orçamentos recebidos 24h por dia" },
      { icon: "ri-search-eye-line", label: "Primeiras posições para termos locais" },
    ],
  },
  {
    client: "Café do Vale",
    segment: "E-commerce de cafés especiais",
    challenge:
      "As vendas estavam limitadas à loja física e a marca queria alcançar clientes de outras regiões.",
    solution:
      "Desenvolvemos uma loja virtual completa, com catálogo, carrinho, checkout e páginas de produto otimizadas para o Google.",
    results: [
      { icon: "ri-shopping-bag-3-line", label: "Loja vendendo para todo o Brasil" },
      { icon: "ri-line-chart-line", label: "Aumento constante no faturamento" },
      { icon: "ri-smartphone-line", label: "Maioria das compras pelo celular" },
    ],
  },
  {
    client: "Clínica Vitalis",
    segment: "Saúde · Clínica multiespecialidade",
    challenge:
      "A clínica precisava divulgar uma nova especialidade e captar agendamentos de forma profissional.",
    solution:
      "Criamos uma landing page focada em conversão, com integração ao WhatsApp e formulário de contato direto.",
    results: [
      { icon: "ri-user-add-line", label: "Mais agendamentos pela internet" },
      { icon: "ri-whatsapp-line", label: "Contato imediato com os pacientes" },
      { icon: "ri-rocket-2-line", label: "Campanha de anúncios ativa" },
    ],
  },
];

export const sitesFaqs = [
  {
    question: "Quanto tempo leva para criar um site?",
    answer:
      "O prazo varia conforme a complexidade do projeto. Depois da conversa inicial, apresentamos uma estimativa de tempo alinhada ao que o seu negócio precisa.",
  },
  {
    question: "O site é responsivo para celular?",
    answer:
      "Sim. Todos os sites que desenvolvemos são pensados primeiro para o celular e funcionam bem em tablets e computadores.",
  },
  {
    question: "O site vem com otimização para o Google?",
    answer:
      "Sim. Trabalhamos a estrutura técnica de SEO, títulos, descrições e performance para o seu site ter uma boa base de indexação.",
  },
  {
    question: "Posso atualizar o conteúdo depois?",
    answer:
      "Sim. Preparamos o projeto para que o conteúdo possa ser atualizado com facilidade, seja pela nossa equipe ou por você.",
  },
  {
    question: "Vocês também registram o domínio e hospedam o site?",
    answer:
      "Sim. Reunimos criação, domínio e hospedagem em um só lugar, facilitando a gestão da sua presença digital.",
  },
];